export default __webpack_public_path__ + "static/media/11.10c17b72.png";